import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
/**
 * Component: Blog article grid
 * ------------------------------------------------------------------------------
 * Storefront API script used on article cards.
 *
 * @namespace blogCategories
 */

import axios from 'axios';
import { on } from '../helpers/utils';
import cssClasses from '../helpers/cssClasses';
import { articleCardHTML } from './templates/blog-grid-template';
/**
 * Storefront API theme settings.
 */

const {
  storefrontAccessToken,
  storefrontUrl
} = theme.features;
const {
  articleTotalCount
} = theme.strings.blog;
let articleViewCount = 0;
/**
 * Graphql storefront API query string.
 * @param {Number} pagination - API pagination.
 * @param {String} cursor - API product marker used for pagination.
 * @param {String} query - API additional queries.
 */

const articleQuery = function articleQuery(pagination) {
  let cursor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return "\n{ articles (\n    first:".concat(pagination, ",\n    reverse:true,\n    sortKey:PUBLISHED_AT,\n    ").concat(cursor === '' ? '' : "after:\"".concat(cursor, "\","), "\n    ").concat(query === '' ? '' : "query:\"".concat(query, "\","), "\n  ) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n    }\n    edges { \n      cursor\n      node { \n        id\n        title\n        onlineStoreUrl \n        excerpt\n        excerptHtml\n        image {\n          originalSrc\n          transformedSrc(maxWidth:1)\n          altText\n        }\n        tags\n      }\n    }\n  }\n}");
};
/**
 * DOM selectors.
 */


const selectors = {
  container: '[js-blog-article="container"]',
  pagination: '[js-blog-article="pagination"]',
  loadMore: '[js-blog-article="loadMore"]',
  count: '[js-blog-article="count"]'
};
/**
 * Storefront API pagination cursror;
 */

let graphCursor = '';
/**
 * Create a new example object.
 */

export default (() => {
  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    container: document.querySelector(selectors.container),
    pagination: document.querySelector(selectors.pagination),
    count: document.querySelector(selectors.count)
  };
  /**
   * Storefront API request callback function.
   *
   * @callback getArticlesCallback
   * @param {Object} data - Storefront response data.
   */

  /**
   * Gets tag handle fron url.
   * @returns {String}
   */

  function getTagValue() {
    const tag = window.location.href.split('tagged/')[1];
    return tag === undefined ? '' : tag;
  }
  /**
   * Storefront API request function
   @param {getArticlesCallback} callback - Callback that handles the response.
   */


  function getArticles(callback) {
    return new Promise((resolve, reject) => {
      const {
        pagination
      } = nodeSelectors.container.dataset;
      const tagQuery = getTagValue();
      axios({
        url: storefrontUrl,
        method: 'post',
        data: {
          query: articleQuery(pagination, graphCursor, tagQuery)
        },
        headers: {
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken
        }
      }).then(response => {
        if (response.data.errors) {
          window.console.error(response.data);
          return response;
        }

        const data = response.data.data;
        resolve(callback(data));
        setGrapCursor(data.articles.edges);
        renderArticleCount(data.articles.edges);
        return response;
      }).catch(error => {
        window.console.error(error);
        reject(error);
        return error;
      });
    });
  }
  /**
   * Sets event listeners.
   */


  function setEventListeners() {
    on('click', nodeSelectors.loadMore, event => appendArticles(event));
  }
  /**
   * Updates productCount.
   * @param {Array} edges - Response API articles data.
   */


  function renderArticleCount(edges) {
    articleViewCount += edges.length;
    nodeSelectors.count.innerHTML = theme.strings.blog.viewed.replace('{{ count }}', articleViewCount).replace('{{ total }}', articleTotalCount);
  }
  /**
   * Renders load more button if there are more articles to display.
   * @param {Object} pageInfo - Storefront API pagination object.
   */


  function renderLoadMoreButton(pageInfo) {
    if (!pageInfo.hasNextPage) {
      return;
    }

    nodeSelectors.pagination.innerHTML = "\n      <button \n        class=\"template-blog__load-more-btn button button--primary\"\n        js-blog-article=\"loadMore\"\n      >\n        <div class=\"loader\"><div class=\"ball-clip-rotate\"><div></div></div></div>\n        <span>".concat(theme.strings.blog.pagination.loadMore, "</span>\n      </button>\n      ");
    nodeSelectors.loadMore = document.querySelector(selectors.loadMore);
    setEventListeners();
  }
  /**
   * Stores last data item's cursor.
   * @param {Array} edges - Response API articles data.
   */


  function setGrapCursor(edges) {
    const lastIndex = edges.length - 1;
    graphCursor = edges[lastIndex].cursor;
  }
  /**
   * Appends more articles to front end.
   * @param {Event} event - Keydown event.
   */


  function appendArticles(event) {
    const {
      currentTarget
    } = event;
    currentTarget.classList.add(cssClasses.loading);
    getArticles(data => {
      const {
        edges,
        pageInfo
      } = data.articles;
      const articlesHTML = edges.map(item => {
        return articleCardHTML(item.node);
      });
      currentTarget.classList.remove(cssClasses.loading);

      if (!pageInfo.hasNextPage) {
        currentTarget.disabled = true;
        currentTarget.classList.add(cssClasses.disabled);
      }

      nodeSelectors.container.insertAdjacentHTML('beforeend', articlesHTML.join(''));
    });
  }
  /**
   * Renders article cards markup.
   */


  function renderArticles() {
    getArticles(data => {
      const {
        edges,
        pageInfo
      } = data.articles;

      if (edges.length === 0) {
        return;
      }

      nodeSelectors.container.innerHTML = edges.map(item => {
        return articleCardHTML(item.node);
      }).join('');
      renderLoadMoreButton(pageInfo);
    });
  }
  /**
   * Initialise component.
   */


  function init() {
    renderArticles();
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});